import PropTypes from 'prop-types';
import styled from 'styled-components';

const ProductDescription = styled.ul`
  .resultGrid & {
    margin: 10px 0;
    color: #666;
    @media ${({ theme }) => theme.breakpoints.mobile} {
      display: none;
    }
  }

  .resultList .desc & {
    margin-top: 0;
    margin-bottom: 10px;
    color: #222;
    @media ${({ theme }) => theme.breakpoints.mobile} {
      text-align: left;
    }
  }
`;

const ProductItemDescriptionBullets = ({ descriptionBullets }) => (
  <ProductDescription className={'productDescription'}>
    {descriptionBullets.map((description, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={i}>{description}</li>
    ))}
  </ProductDescription>
);

ProductItemDescriptionBullets.propTypes = {
  descriptionBullets: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default ProductItemDescriptionBullets;
